<template>
    <section class="bg-nomad-accent px-6 pb-20 pt-16 text-nomad-primary sm:pb-28 sm:pt-20">
        <div class="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
            <div>
                <p class="w-fit rounded-full border border-nomad-primary/20 bg-white/35 px-3 py-1 text-xs font-extrabold uppercase tracking-[0.16em] text-nomad-primary/75">What we do</p>
                <h1 class="mt-6 max-w-3xl text-5xl font-extrabold leading-[0.98] tracking-tight sm:text-6xl lg:text-7xl">Visionary solutions from concept to success.</h1>
                <p class="mt-6 max-w-2xl text-lg leading-relaxed text-nomad-primary/75 sm:text-xl">Tailored design, development, marketing, and technical services built around your business goals.</p>
            </div>
            <div class="flex justify-center lg:justify-end">
                <img src="/assets/images/discover-mock-text.svg" class="w-full max-w-[34rem] rounded-[1.5rem] p-2 shadow-[0_1rem_2.5rem_rgba(42,38,64,0.12)]" alt="Nexa digital product design preview">
            </div>
        </div>
    </section>
    <Container class="flex flex-col gap-8">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div>
                <p class="text-xs font-extrabold uppercase tracking-[0.16em] text-nomad-primary/60">Our capabilities</p>
                <h2 class="mt-2 text-4xl font-extrabold tracking-tight text-nomad-primary sm:text-5xl">Built for the next move.</h2>
            </div>
            <p class="max-w-md text-base leading-relaxed text-nomad-primary/65 sm:text-right">From the first idea to the systems that help it grow, we bring strategy and execution together.</p>
        </div>
        <div class="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
            <article v-for="service in services" :key="service.id" class="group flex min-h-[18rem] flex-col rounded-[1.5rem] border p-6 shadow-[0_0.6rem_1.5rem_rgba(23,25,35,0.05)] transition duration-200 hover:-translate-y-1 hover:shadow-[0_1rem_2rem_rgba(23,25,35,0.1)]" :class="service.featured ? 'border-nomad-primary bg-nomad-primary text-white' : 'border-[#E5E4E1] bg-[#F7F7F5]'">
                <div class="flex h-12 w-12 items-center justify-center rounded-xl p-3" :class="service.featured ? 'bg-nomad-accent' : 'bg-nomad-primary'">
                    <component :is="service.icon" class="h-full w-full" :class="service.featured ? 'text-nomad-primary' : 'text-nomad-accent'" :stroke-width="2" aria-hidden="true" />
                </div>
                <p v-if="service.featured" class="mt-5 text-xs font-extrabold uppercase tracking-[0.16em] text-nomad-accent">New capability</p>
                <h3 class="mt-6 text-xl font-extrabold" :class="service.featured ? 'text-white' : 'text-nomad-primary'">{{ service.title }}</h3>
                <p class="mt-3 text-base leading-relaxed" :class="service.featured ? 'text-white/75' : 'text-[#5F626D]'">{{ service.description }}</p>
                <div class="mt-auto flex items-center gap-2 pt-6" aria-hidden="true">
                    <span class="h-px w-8" :class="service.featured ? 'bg-white/30' : 'bg-nomad-primary/20'"></span>
                    <span class="h-1.5 w-1.5 rounded-full bg-nomad-accent"></span>
                </div>
            </article>
        </div>
    </Container>
    <Container>
        <C2a title="Hourly Support Subscription"
            subtitle="Access Dedicated Assistance and Support at an Average Rate of $72.8 This Year" cta="Pay now"
            url="/" />
    </Container>
</template>
<script>
import C2a from '@/components/C2a.vue';
import Container from '@/layouts/Container.vue';
import { Code2, Database, Globe2, Megaphone, PlugZap, Search } from '@lucide/vue';
export default {
    components: {
        C2a,
        Container,
        Code2,
        Database,
        Globe2,
        Megaphone,
        PlugZap,
        Search
    },
    data() {
        return {
            services: [

                {
                    id: 1,
                    title: 'Research & Planning',
                    description: 'Our cross-functional design, development, and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights, and your business goals.',
                    icon: Search
                },
                {
                    id: 2,
                    title: 'GEO & AI Visibility',
                    description: 'Prepare your website for AI-powered search and discovery. We are perfecting GEO strategies that help platforms understand your business and surface it in the right conversations.',
                    icon: Globe2,
                    featured: true
                },
                {
                    id: 3,
                    title: 'Design & Development',
                    description: 'Our cross-functional design, development, and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights, and your business goals.',
                    icon: Code2
                },
                {
                    id: 4,
                    title: 'Lead Generation',
                    description: 'Generate high-quality leads with our strategic lead generation services. Our team leverages data and technology to drive potential customers to your business, boosting your sales and growth.',
                    icon: Database
                },
                {
                    id: 5,
                    title: 'Ads',
                    description: 'Maximize your online visibility and reach your target audience through effective advertising campaigns. Our experts create and manage ads that drive results and enhance your brand presence.',
                    icon: Megaphone
                },
                {
                    id: 6,
                    title: 'Third-Party Integration',
                    description: 'Seamlessly integrate third-party solutions and tools into your digital ecosystem. Our experienced team ensures that your systems work harmoniously to enhance efficiency and functionality.',
                    icon: PlugZap
                }


            ]
        }
    }
}
</script>